export * from './post-erinnerung.component';
export * from './post-erinnerung.component.module';